export const ROUTES = {
    // public routes
    MAIN: "/",
    REGISTRATION: "/registration",
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    PROFILE: "/profile",
    FINANCES: "/finances",
    CAMPAIGNS: "/campaigns",
    PAYMENT_SUCCESS: "/payment/success",
    PAYMENT_FAILED: "/payment/failed",
    NOT_FOUND: "*",
} as const;

export type RoutesType = (typeof ROUTES)[keyof typeof ROUTES];
